import { render, staticRenderFns } from "./ArticleInfoSmallTemplate.vue?vue&type=template&id=61cb1163"
import script from "./ArticleInfoSmallTemplate.vue?vue&type=script&lang=ts"
export * from "./ArticleInfoSmallTemplate.vue?vue&type=script&lang=ts"
import style0 from "./ArticleInfoSmallTemplate.vue?vue&type=style&index=0&id=61cb1163&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports